module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product4-331a38e3b99f1d83660006ba23fb96e7.jpg";